export default __webpack_public_path__ + "static/media/fridge2-afterA-1024w.80866810.webp";